import { Button } from '@material-ui/core';
import { PrintOutlinedIcon } from 'components/icons/print-outlined';
import React from 'react';
import { PenCardsButtonProps } from './pen-cards-button-props';
import './pen-cards-button.scss';

export const PenCardsButton: React.FC<PenCardsButtonProps> = (props) => {
  const {
    id,
    db,
    trait,
    user,
    breederId,
    breederName,
    disabled,
  } = props;

  let href = `my/pen-card/${id}?&user=${user}&db=${db}&breederId=${breederId}&breederName=${breederName}`;

  if (trait) {
    href += `&scenario=${trait}`;
  }

  return (
    <div className="sg-pen-cards-button">
      <Button
        variant="text"
        className="sg-button"
        href={href}
        startIcon={<PrintOutlinedIcon />}
        disabled={disabled}
      >
        Pen cards
      </Button>
    </div>
  );
};
